import MuiButton from "@mui/material/Button";
import { ThemeProvider } from '@mui/material/styles';

import { theme } from '../Theme';

const Button = (props) => <ThemeProvider theme={theme}><MuiButton variant="contained" {...props} /></ThemeProvider>;

export default Button;
